/**
 * A song's own colour.
 *
 * The Collective already committed to this: each song gets a stable hue from
 * its id so its lyric card is a field rather than a void. It was the one
 * screen in the app with an identity, and the palette sat inside
 * routes/Collective.jsx where nothing else could reach it — so every other
 * song in the product rendered as the same grey square.
 *
 * Same six values, moved out here unchanged so Home, Me, Catalog, the song
 * room, the vault, the mini-player and the profile all colour a song the
 * same way. Two songs that look alike on Home look alike in the Collective;
 * that only holds while there is one generator.
 */
export const SONG_HUES = ['#c99a2e', '#7b6fd0', '#2f7d68', '#b4614a', '#3f6ea8', '#8c5a7d']

/** Stable per-id pick. Same id, same colour, every screen, every session. */
export const hueFor = (id) => {
  let n = 0
  for (let i = 0; i < (id || '').length; i++) n = (n * 31 + id.charCodeAt(i)) % 997
  return SONG_HUES[n % SONG_HUES.length]
}

/**
 * Artwork fill for a square or card. A flat swatch reads as a colour chip;
 * the same hue lit from the top-left reads as a printed sleeve, which is the
 * noun we want. Light enough at the top for white type to hold on the bottom
 * half, which is where every caption in this app sits.
 */
export const artGradient = (id) => {
  const h = hueFor(id)
  return `linear-gradient(150deg, ${h} 0%, ${h}cc 46%, #0d0c10 160%)`
}

/**
 * The Collective's own deeper treatment — a radial field behind lyrics
 * rather than a small square. Kept here beside the palette so the feed and
 * the artwork can never drift apart.
 */
export const lyricField = (id) => {
  const h = hueFor(id)
  return `radial-gradient(120% 90% at 50% 30%, ${h}, ${h}bb 45%, #0d0c10)`
}

